/** 업로드 이미지 주소 — 네이버 Object Storage(CDN). 경로는 /images/... 그대로 (server routers/common/objectStorage.js) */
const ImageURL = 'https://kr.object.ncloudstorage.com/ministermore-gallery';

export default ImageURL;
